export default __webpack_public_path__ + "static/media/linkedin.5cfae5ae.svg";